import EndState from 'src/game/states/EndState';
import {GameMode, GameState} from './GameMode';
import {Game} from 'src/game/Game';
import {StateCtor} from 'src/game/states/State';
import PlaceState from 'src/game/states/PlaceState';
import FireState from 'src/game/states/FireState';
import BuildState from 'src/game/states/BuildState';
import {Spawn, MapState} from '../map/MapState';
import {Location} from '../map/Location';
import FFASelectState from 'src/game/states/FFASelectState';

export class FFAGameMode implements GameMode {
    public game: Game;
    public readonly states: {[key in GameState]: StateCtor} = {
        select: FFASelectState,
        place: PlaceState,
        fire: FireState,
        build: BuildState,
        end: EndState,
    };
    public readonly startState: GameState = 'select';
    public readonly showBuildability: boolean = false;

    public possibleSpawnsForPlayer(_playerIndex: number): Spawn[] {
        return this.map.unheldSpawns();
    }

    public canBuildAtLocation(map: MapState, tiles: Location[], playerIndex: number): boolean {
        return tiles.some(loc =>
            map.valid4Neighbors(loc).some(loc => map.isPlayerWall(loc, playerIndex))
        );
    }

    private get map(): MapState {
        return this.game.map;
    }
}



// WEBPACK FOOTER //
// ./src/common/modes/FFAGameMode.ts